import Decimal from "decimal.js-light";
import { getUnit } from "../constants/units";
const getLoadmeterValueFromUnitAndQuantity = (unitId, quantity) => {
    const unit = getUnit(unitId);
    if (unit.value) {
        return new Decimal(quantity).mul(unit.value).mul(120).div(24000);
    }
    return null;
};
export { getLoadmeterValueFromUnitAndQuantity };
//# sourceMappingURL=get-loadmeter-value-from-unit-and-quantity.js.map